import React from "react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { toGermanNumberFormat } from "@helpers";

const ValuesWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: ${({ theme }) => theme.spacing(4)};
  overflow: auto;
  margin: ${({ theme }) => theme.spacing(1, 0)};
`;

const AssetNameContainer = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

const AssetColorDot = styled.div<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${({ color }) => color};
`;

export interface TooltipItem {
  x: number;
  value: number;
  name: string;
  color: string;
}

interface Props {
  data: TooltipItem[];
}

export const SecuritiesChartMobileTooltips = ({ data }: Props) => {
  return (
    <ValuesWrapper>
      {data.map((item) => (
        <div key={item.name}>
          <Typography color="textPrimary" variant="body3">
            {toGermanNumberFormat(item.value)}
          </Typography>
          <AssetNameContainer>
            <AssetColorDot color={item.color} />
            <Typography color="textSecondary" variant="caption">
              {item.name}
            </Typography>
          </AssetNameContainer>
        </div>
      ))}
    </ValuesWrapper>
  );
};
